import { __assign, __extends } from "tslib";
import React from "react";
import { PnmacScroller, PnmacInterstitialCompontent, PnmacCard, PnmacText } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import moment from 'moment';
import { bindActionCreators } from "redux";
import { View } from 'react-native';
import { textStyle } from '../v2/theme';
import { currencyFormatter, encryptBankAccountNumber } from '../utils.js';
var Interstitial = /** @class */function (_super) {
  __extends(Interstitial, _super);
  function Interstitial(props) {
    var _this = _super.call(this, props) || this;
    _this.deletePayment = function (callback) {
      _this.setState({
        loading: true
      });
      var layout = _this.props.layout;
      fetch("".concat(layout.pennyHomeUrl, "api/payment/delete_payment"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token),
          "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
        },
        body: JSON.stringify(__assign(__assign({}, _this.state.payment), {
          bankAccount: __assign(__assign({}, _this.state.payment.bankAccount), {
            unmaskedAccountNumber: undefined,
            confirmAccountNumber: undefined,
            confirmAccountNumberEncode: encryptBankAccountNumber(_this.state.payment.bankAccount.confirmAccountNumber)
          })
        }))
      }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        }
        callback();
        return null;
      }).then(function (data) {
        callback();
        _this.setState({
          loading: false
        });
      });
    };
    _this.submitPayment = function () {
      _this.setState({
        loading: true
      });
      var _a = _this.props,
        layout = _a.layout,
        payment = _a.payment;
      var pay = payment();
      var that = _this;
      var openedWindow = window.open("/post_debit_payment", '_blank');
      pay.effectiveDate = moment(pay.effectiveDate).format("MM/DD/YYYY");
      fetch("".concat(layout.pennyHomeUrl, "api/payment/post_debit_payment"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token),
          "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
        },
        body: JSON.stringify(_this.state.payment)
      }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        } else {
          _this.channel.postMessage({
            error: true
          });
        }
        return null;
      }).then(function (data) {
        var _a;
        if (data && ((_a = Object.keys((data === null || data === void 0 ? void 0 : data.errors) || {})) === null || _a === void 0 ? void 0 : _a.length) == 0) {
          _this.setState({
            payment: data === null || data === void 0 ? void 0 : data.payment
          }, function () {
            setTimeout(function () {
              that.channel.postMessage(data);
            }, 500);
          });
        } else {
          openedWindow.close();
          _this.props.timeCallback(data === null || data === void 0 ? void 0 : data.errors);
          _this.setState({
            errors: data === null || data === void 0 ? void 0 : data.errors
          }, function () {
            setTimeout(function () {
              that.channel.postMessage({
                error: true
              });
            }, 1000);
          });
        }
        _this.setState({
          loading: false
        });
      });
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.state = {
      errors: [],
      payment: null,
      loading: false
    };
    _this.channel = new BroadcastChannel('app-data');
    return _this;
  }
  Interstitial.prototype.componentDidMount = function () {
    PnmacScroller(0, 0);
    if (!this.props.layout.mobile) {
      document.addEventListener("message", function (data) {
        setTimeout(function () {
          document.postMessage(true);
        }, 2000);
        this.setState({
          webview: data.data
        });
      });
    }
  };
  Interstitial.getDerivedStateFromProps = function (props, state) {
    if (!state.payment && props.payment) {
      return __assign(__assign({}, state), {
        payment: props.payment()
      });
    }
    return null;
  };
  Interstitial.prototype.render = function () {
    var _this = this;
    var _a, _b;
    var _c = this.props,
      translations = _c.translations,
      layout = _c.layout,
      closeModal = _c.closeModal,
      debitFee = _c.debitFee;
    var _d = this.state,
      errors = _d.errors,
      loading = _d.loading;
    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_a = Object.keys(errors)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        padding: 15,
        backgroundColor: "pink"
      }
    }, Object.keys(errors).map(function (s) {
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, s, " ::: ", errors[s]));
    })) : null, /*#__PURE__*/React.createElement(PnmacInterstitialCompontent, __assign({}, {
      loading: loading,
      headerText: translations.InterstitialHeading,
      goTo: function () {
        return _this.submitPayment();
      },
      goBack: function () {
        _this.deletePayment(function () {
          closeModal();
          _this.channel.postMessage({
            error: true
          });
        });
      },
      bodyWarning: translations.InterstitialBodyWarning,
      bodyNotes: (_b = translations.InterstitialBodyNotes) === null || _b === void 0 ? void 0 : _b.replace("{0}", currencyFormatter('en-US', 'currency', 'USD', debitFee)),
      BtnGoBackText: translations.InterstitialCancelBtn,
      btnGoToText: translations.InterstitialConfirmBtn,
      url: "".concat(layout.pennyHomeUrl, "Leaving?ids_token=").concat(layout.token),
      bodyToCancelText: translations.InterstitialBodyToCancelText
    })));
  };
  return Interstitial;
}(React.PureComponent);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(Interstitial);